const domain = 'custlogin.pp.gm.com'
const policy = 'B2C_1A_SeamlessMigration_SignUpOrSignIn'

export const MSalConfig = {
	approvedAuthorities: [domain],
	authority: `https://${domain}/gmb2ctest.onmicrosoft.com/${policy}`,
	clientID: '2816e68f-d202-4b18-9cc1-809160ffd363',
	policy,
	tenant: domain,
}
